<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3">
              <label>{{ $t('common_words.farm') }} *</label>
              <br />
              <el-select
                clearable
                @clear="cleanFarm()"
                @change="showCalendar()"
                filterable
                class="select-primary custom-width-select required-farm shadow-sm farm-form"
                size="large"
                v-model="generalCuttingForm.farm_id"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="(option, index) in farms"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="index + option.id"
                />
              </el-select>
            </div>

            <div
              class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3"
              v-if="isShowCalendar"
            >
              <label>{{ $t('common_words.calendar') }} *</label>
              <br />
              <el-select
                clearable
                filterable
                class="select-primary custom-width-select required-calendar shadow-sm date-form"
                size="large"
                v-model="generalCuttingForm.calendar_sel"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="(option, index) in calendars"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="index + option.id"
                />
              </el-select>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <label>{{ $t('common_words.date') }} *</label>
              <br />
              <el-date-picker
                v-if="renderComponent"
                :picker-options="pickerOptions"
                class="shadow-sm required-date date-form"
                v-model="generalCuttingForm.date_sel"
                type="date"
                :disabled="isFromReport"
                :placeholder="`${$t('common_words.select2')}...`"
              />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
              <div class="row custom-mt-30">
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2">
                  <l-button
                    wide
                    type="info"
                    class="btn-filter"
                    @click="validate"
                    style="width: inherit"
                  >
                    {{ $t('common_words.generate') }}
                  </l-button>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla Detalles -->
    <div class="row mt-2" v-if="showTable">
      <div class="col-12">
        <card
          class="custom-shadow-card-header custom-table-responsive"
          :title="$t('common_words.details')"
        >
          <div class="row">
            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.production_area') }}*</label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-production_area"
                v-model="generalCuttingForm.production_area"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.traveled_area') }}*</label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-traveled_area"
                v-model="generalCuttingForm.traveled_area"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label
                >{{ $t('generalcutting.average_cluster_weight') }} ({{
                  generalCuttingForm.unit_tara_weight
                }})*
              </label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-average_cluster_weight"
                v-model="generalCuttingForm.average_cluster_weight"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label
                >{{ $t('generalcutting.average_stem_weight') }} ({{
                  generalCuttingForm.unit_tara_weight
                }})*
              </label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-average_stem_weight"
                v-model="generalCuttingForm.average_stem_weight"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.average_number_hands') }}*</label>
              <fg-input
                type="number"
                min="0"
                step="1"
                class="input-covered_area required-"
                v-model="generalCuttingForm.average_number_hands"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                {{ $t('generalcutting.average_length_second_hand') }}
                ({{ generalCuttingForm.length_unit }})*
              </label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-average_length_second_hand"
                v-model="generalCuttingForm.average_length_second_hand"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                {{ $t('generalcutting.average_length_last_hand') }}
                ({{ generalCuttingForm.length_unit }})*
              </label>
              <fg-input
                type="number"
                min="0"
                step="0.01"
                class="input-covered_area required-average_length_last_hand"
                v-model="generalCuttingForm.average_length_last_hand"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label
                >{{ $t('generalcutting.average_number_fingers_box') }}*</label
              >
              <fg-input
                type="number"
                min="0"
                step="1"
                class="input-covered_area required-average_number_fingers_box"
                v-model="generalCuttingForm.average_number_fingers_box"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label
                >{{
                  $t('generalcutting.average_clusters_total_fingers')
                }}*</label
              >
              <fg-input
                type="number"
                min="0"
                step="1"
                class="input-covered_area required-average_clusters_total_fingers"
                v-model="generalCuttingForm.average_clusters_total_fingers"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.quantity_people_packing') }}*</label>
              <fg-input
                type="number"
                min="0"
                step="1"
                class="input-covered_area required-quantity_people_packing"
                v-model="generalCuttingForm.quantity_people_packing"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.quantity_people_harvest') }}*</label>
              <fg-input
                type="number"
                min="0"
                step="1"
                class="input-covered_area required-quantity_people_harvest"
                v-model="generalCuttingForm.quantity_people_harvest"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.work_start_time') }}*</label>
              <el-time-picker
                v-model="generalCuttingForm.work_start_time"
                style="width: 100%"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                class="required-work_start_time"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>{{ $t('generalcutting.work_end_time') }}*</label>
              <el-time-picker
                v-model="generalCuttingForm.work_end_time"
                style="width: 100%"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                class="required-work_end_time"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{
                  $t('generalcutting.percent_traveled_area')
                }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.01"
                class="input-covered_area"
                :value="percentTraveledArea"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{
                  $t('generalcutting.percent_rejected_clusters')
                }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.01"
                class="input-covered_area"
                :value="percentRejectedClusters"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{ $t('generalcutting.cut_total_ratio') }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.0001"
                class="input-covered_area"
                :value="cutTotalRatio"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{
                  $t('generalcutting.processed_total_ratio')
                }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.0001"
                class="input-covered_area"
                :value="processedTotalRatio"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>
                  {{ $t('generalcutting.average_weight_without_stem') }}
                  ({{ generalCuttingForm.unit_tara_weight }})
                </strong>
              </label>
              <fg-input
                type="number"
                step="0.01"
                class="input-covered_area"
                :value="averageWeightWithoutStem"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{
                  $t('generalcutting.percent_cut_total_loss')
                }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.01"
                class="input-covered_area"
                :value="totalCutLossPercent"
                disabled
              />
            </div>

            <div class="col-md-3 mb-3">
              <label>
                <strong>{{
                  $t('generalcutting.percent_processed_total_loss')
                }}</strong>
              </label>
              <fg-input
                type="number"
                step="0.01"
                class="input-covered_area"
                :value="totalProcessedLossPercent"
                disabled
              />
            </div>

            <div class="col-12 mb-3">
              <label>{{ $t('common_words.observation') }}</label>
              <el-input
                maxlength="300"
                show-word-limit
                type="textarea"
                :rows="3"
                placeholder="..."
                v-model="generalCuttingForm.observation"
                class="shadow-sm"
              ></el-input>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla Racimos cortados -->
    <div class="row mt-2" v-if="showTable">
      <div class="col-12">
        <card
          class="custom-shadow-card-header custom-table-responsive"
          :title="$t('generalcutting.cluster_cut')"
        >
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead class="cusmtom-thead-color">
                <tr class="cusmtom-thead-color">
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.age') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('production.ribbon') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.quantity') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('calibration.calibration') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.options') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(_, index) in generalCuttingForm.nGeneralClusters"
                  :key="`gc-${index}`"
                >
                  <td class="text-center custom-td-pd" style="min-width: 120px">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="getAvailableAges(index)"
                      :requireClass="`required-general_cluster_age`"
                      :initialSelection="
                        generalCuttingForm.general_clusters[index].age
                      "
                      :indexSelect="index"
                      @onChange="handleGeneralClusterChange"
                      modelName="age"
                    />
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 140px">
                    <span
                      v-if="generalCuttingForm.general_clusters[index].age"
                      class="col-12"
                      :style="getGeneralClusterRibbonStyle(index)"
                    >
                      {{ getGeneralClusterRibbonName(index) }}
                    </span>
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 120px">
                    <fg-input
                      type="number"
                      min="0"
                      step="1"
                      class="m-3 text-center"
                      v-model="
                        generalCuttingForm.general_clusters[index].quantity
                      "
                    />
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 140px">
                    <fg-input
                      type="number"
                      min="0"
                      step="0.01"
                      class="m-3 text-center"
                      v-model="
                        generalCuttingForm.general_clusters[index]
                          .calibration_average
                      "
                    />
                  </td>
                  <td class="text-center custom-td-pd" style="min-width: 120px">
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addGeneralClusterRow()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          generalCuttingForm.nGeneralClusters > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="removeGeneralClusterRow(index)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="text-center">
                    <strong>{{ $t('common_words.total') }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ totalGeneralClustersQuantity }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ averageGeneralClustersCalibration }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla Racimos rechazados -->
    <div class="row mt-2" v-if="showTable">
      <div class="col-12">
        <card
          class="custom-shadow-card-header custom-table-responsive"
          :title="$t('generalcutting.cluster_rejected')"
        >
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead class="cusmtom-thead-color">
                <tr class="cusmtom-thead-color">
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('production.motive') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.quantity') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.options') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(_, index) in generalCuttingForm.nRejectedClusters"
                  :key="`gr-${index}`"
                >
                  <td class="text-center custom-td-pd" style="min-width: 320px">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="getAvailableCauses(index)"
                      :requireClass="`required-rejected_cause`"
                      :initialSelection="
                        generalCuttingForm.general_rejected_clusters[index]
                          .cause_rejected_cluster_id
                      "
                      :indexSelect="index"
                      @onChange="handleRejectedClusterChange"
                      modelName="cause_rejected_cluster_id"
                    />
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 120px">
                    <fg-input
                      type="number"
                      min="0"
                      step="1"
                      class="m-3 text-center"
                      v-model="
                        generalCuttingForm.general_rejected_clusters[index]
                          .quantity
                      "
                    />
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 120px">
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addRejectedClusterRow()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          generalCuttingForm.nRejectedClusters > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="removeRejectedClusterRow(index)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-center">
                    <strong>{{ $t('common_words.total') }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ totalRejectedClustersQuantity }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla Cajas -->
    <div class="row mt-2" v-if="showTable">
      <div class="col-12">
        <card
          class="custom-shadow-card-header custom-table-responsive"
          :title="$t('production.boxes')"
        >
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead class="cusmtom-thead-color">
                <tr class="cusmtom-thead-color">
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('production.box') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('production.crafted') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('production.rejected_2') }}
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    Exportadas
                  </th>
                  <th class="text-center p-3 custom-header-label">
                    {{ $t('common_words.options') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(_, index) in generalCuttingForm.nGeneralBoxes"
                  :key="`gb-${index}`"
                >
                  <td class="text-center custom-td-pd" style="min-width: 280px">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="getAvailableBoxes(index)"
                      :requireClass="`required-box`"
                      :initialSelection="
                        generalCuttingForm.general_boxes[index].box_id
                      "
                      :indexSelect="index"
                      @onChange="handleGeneralBoxChange"
                      modelName="box_id"
                    />
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 100px">
                    <fg-input
                      type="number"
                      min="0"
                      step="1"
                      class="m-3 text-center"
                      v-model="generalCuttingForm.general_boxes[index].quantity"
                    />
                  </td>

                  <td class="custom-td-pd" style="min-width: 100px">
                    <fg-input
                      type="number"
                      min="0"
                      step="1"
                      class="m-2 text-center"
                      v-model="generalCuttingForm.general_boxes[index].rejected"
                    />
                  </td>

                  <td
                    class="text-center custom-td-pd align-middle"
                    style="min-width: 100px"
                  >
                    {{ getExportedBoxes(index) }}
                  </td>

                  <td class="text-center custom-td-pd" style="min-width: 100px">
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addGeneralBoxRow()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          generalCuttingForm.nGeneralBoxes > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="removeGeneralBoxRow(index)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-center">
                    <strong>{{ $t('common_words.total') }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ totalGeneralBoxesQuantity }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ totalGeneralBoxesRejected }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ totalGeneralBoxesExported }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>

    <!-- Botones -->
    <card class="custom-shadow-card-header" v-if="showTable">
      <div class="row">
        <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
          <l-button
            wide
            type="info"
            class="btn-filter m-4"
            @click="saveGeneralCutting"
          >
            {{ $t('common_words.save') }}
          </l-button>
        </div>
        <div class="col-6 text-left" v-if="isDelete()">
          <l-button
            wide
            type="danger"
            class="btn-filter m-4"
            @click="deleteGeneralCutting"
          >
            {{ $t('common_words.delete') }}
          </l-button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      generalCuttingForm: {
        calendar_sel: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        farm_id: null,
        user_id: this.$store.state.auth.user.id,

        observation: '',
        production_area: null,
        traveled_area: null,
        average_cluster_weight: null,
        average_stem_weight: null,
        average_number_hands: null,
        average_length_second_hand: null,
        average_length_last_hand: null,
        average_number_fingers_box: null,
        average_clusters_total_fingers: null,
        quantity_people_packing: null,
        quantity_people_harvest: null,
        work_start_time: null,
        work_end_time: null,
        unit_tara_weight: null,
        length_unit: null,

        nGeneralClusters: 1,
        nRejectedClusters: 1,
        nGeneralBoxes: 1,

        general_clusters: [
          {
            ribbon_id: null,
            ribbon_name: null,
            ribbon_color: null,
            ribbon_text_color: null,
            age: null,
            quantity: null,
            calibration_average: null,
            latitude: null,
            longitude: null,
            altitude: null,
            full_date: null,
          },
        ],

        general_rejected_clusters: [
          {
            cause_rejected_cluster_id: null,
            quantity: null,
            latitude: null,
            longitude: null,
            altitude: null,
            full_date: null,
          },
        ],

        general_boxes: [
          {
            box_id: null,
            quantity: null,
            rejected: null,
            latitude: null,
            longitude: null,
            altitude: null,
            full_date: null,
          },
        ],
      },

      general_cutting_header_id: null,
      has_details: false,
      farms: [],
      isShowCalendar: false,
      showTable: false,
      showPreload: false,
      messageAlert: null,
      ribbonsWeeks: [],
      causes: [],
      boxesCatalog: [],
      location: null,
      isFromReport: false,

      modelValidations: {
        production_area: {
          required: true,
          max: 6,
          min_value: 0,
        },
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  computed: {
    calendars() {
      if (this.generalCuttingForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.generalCuttingForm.farm_id) {
            calendars = element.calendars;
          }
        });
        return calendars;
      }
      return [];
    },

    ages() {
      return [
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
        { id: 16, name: '16' },
        { id: 17, name: '17' },
        { id: 18, name: '18' },
      ];
    },

    // Total Racimos Cortados o Racimos cosechados
    totalGeneralClustersQuantity() {
      return this.generalCuttingForm.general_clusters.reduce(
        (acc, item) => acc + Number(item.quantity || 0),
        0
      );
    },

    // Promedio de Calibracion
    averageGeneralClustersCalibration() {
      const rowsWithCalibration =
        this.generalCuttingForm.general_clusters.filter(
          (item) =>
            item.calibration_average !== null &&
            item.calibration_average !== '' &&
            !isNaN(Number(item.calibration_average))
        );

      if (!rowsWithCalibration.length) return 0;

      const sum = rowsWithCalibration.reduce(
        (acc, item) => acc + Number(item.calibration_average || 0),
        0
      );

      return (sum / rowsWithCalibration.length).toFixed(2);
    },

    // Total Racimos Rechazados
    totalRejectedClustersQuantity() {
      return this.generalCuttingForm.general_rejected_clusters.reduce(
        (acc, item) => acc + Number(item.quantity || 0),
        0
      );
    },

    // Total Cajas Producidas o Elaboradas
    totalGeneralBoxesQuantity() {
      return this.generalCuttingForm.general_boxes.reduce(
        (acc, item) => acc + Number(item.quantity || 0),
        0
      );
    },

    // Total Cajas Producidas o Elaboradas teniendo en cuenta el factor de conversion
    totalConversionFactorBoxesQuantity() {
      return this.generalCuttingForm.general_boxes.reduce((acc, item) => {
        const quantity = Number(item.quantity || 0);

        const selectedBox = this.boxesCatalog.find(
          (box) => box.id === item.box_id
        );

        const conversionFactor = selectedBox
          ? Number(selectedBox.conversion_factor || 1)
          : 1;

        return acc + quantity * conversionFactor;
      }, 0);
    },

    // Total Cajas Rechazadas
    totalGeneralBoxesRejected() {
      return this.generalCuttingForm.general_boxes.reduce(
        (acc, item) => acc + Number(item.rejected || 0),
        0
      );
    },

    // Total Cajas Exportadas
    totalGeneralBoxesExported() {
      return this.generalCuttingForm.general_boxes.reduce(
        (acc, item) =>
          acc + (Number(item.quantity || 0) - Number(item.rejected || 0)),
        0
      );
    },

    // Total Racimos Procesados o Producidos
    totalHarvestedProduced() {
      return (
        Number(this.totalGeneralClustersQuantity || 0) -
        Number(this.totalRejectedClustersQuantity || 0)
      );
    },

    // % Area Recorrida
    percentTraveledArea() {
      const traveled = Number(this.generalCuttingForm.traveled_area || 0);
      const production = Number(this.generalCuttingForm.production_area || 0);

      if (!production) return 0;
      return ((traveled / production) * 100).toFixed(2);
    },

    // % Racimos Recusados
    percentRejectedClusters() {
      const rejected = Number(this.totalRejectedClustersQuantity || 0);
      const cut = Number(this.totalGeneralClustersQuantity || 0);

      if (!cut) return 0;
      return ((rejected / cut) * 100).toFixed(2);
    },

    // Ratio Total Cortado
    cutTotalRatio() {
      const boxes = Number(this.totalConversionFactorBoxesQuantity || 0);
      const cut = Number(this.totalGeneralClustersQuantity || 0);

      if (!cut) return 0;
      return (boxes / cut).toFixed(2);
    },

    // Ratio Total Procesado
    processedTotalRatio() {
      const boxes = Number(this.totalConversionFactorBoxesQuantity || 0);
      const processed = Number(this.totalHarvestedProduced || 0);

      if (!processed) return 0;
      return (boxes / processed).toFixed(2);
    },

    // Promedio Peso Sin Vástago
    averageWeightWithoutStem() {
      const clusterWeight = Number(
        this.generalCuttingForm.average_cluster_weight || 0
      );
      const stemWeight = Number(
        this.generalCuttingForm.average_stem_weight || 0
      );

      return (clusterWeight - stemWeight).toFixed(2);
    },

    // Peso por caja
    fixedBoxWeight() {
      return 18.86;
    },

    // % Merma Total Cortada
    totalCutLossPercent() {
      const RCo = Number(this.totalGeneralClustersQuantity || 0);
      const PR = Number(this.averageWeightWithoutStem || 0);
      const CJ = Number(this.totalConversionFactorBoxesQuantity || 0);
      const PC = Number(this.fixedBoxWeight || 0);

      const base = RCo * PR;
      if (!base) return 0;

      return (((base - CJ * PC) / base) * 100).toFixed(2);
    },

    // % Merma Total Procesada
    totalProcessedLossPercent() {
      const RC = Number(this.totalHarvestedProduced || 0);
      const PR = Number(this.averageWeightWithoutStem || 0);
      const CJ = Number(this.totalConversionFactorBoxesQuantity || 0);
      const PC = Number(this.fixedBoxWeight || 0);

      const base = RC * PR;
      if (!base) return 0;

      return (((base - CJ * PC) / base) * 100).toFixed(2);
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
    MixinForm,
    mixinLocation,
  ],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    async loadFromRouteEdit() {
      const raw = sessionStorage.getItem('generalCuttingEdit');

      if (!raw) {
        this.isFromReport = false;
        return;
      }

      let data = null;

      try {
        data = JSON.parse(raw);
      } catch (e) {
        sessionStorage.removeItem('generalCuttingEdit');
        this.isFromReport = false;
        return;
      }

      const { farm_id, save_date } = data || {};

      this.isFromReport = true;
      this.generalCuttingForm.farm_id = farm_id;
      this.generalCuttingForm.date_sel = moment(save_date, 'YYYY-MM-DD');

      this.showCalendar();

      this.$nextTick(() => {
        this.validate();
      });
    },

    getAvailableAges(index) {
      const selectedAges = this.generalCuttingForm.general_clusters
        .map((item, idx) => (idx !== index ? item.age : null))
        .filter((value) => value !== null && value !== '');

      return this.ages.filter(
        (age) =>
          !selectedAges.includes(age.id) ||
          age.id === this.generalCuttingForm.general_clusters[index].age
      );
    },

    getAvailableCauses(index) {
      const selectedCauses = this.generalCuttingForm.general_rejected_clusters
        .map((item, idx) =>
          idx !== index ? item.cause_rejected_cluster_id : null
        )
        .filter((value) => value !== null && value !== '');

      return this.causes.filter(
        (cause) =>
          !selectedCauses.includes(cause.id) ||
          cause.id ===
            this.generalCuttingForm.general_rejected_clusters[index]
              .cause_rejected_cluster_id
      );
    },

    getAvailableBoxes(index) {
      const selectedBoxes = this.generalCuttingForm.general_boxes
        .map((item, idx) => (idx !== index ? item.box_id : null))
        .filter((value) => value !== null && value !== '');

      return this.boxesCatalog.filter(
        (box) =>
          !selectedBoxes.includes(box.id) ||
          box.id === this.generalCuttingForm.general_boxes[index].box_id
      );
    },

    getExportedBoxes(index) {
      const row = this.generalCuttingForm.general_boxes[index];
      return Number(row.quantity || 0) - Number(row.rejected || 0);
    },

    cleanFarm() {
      this.messageAlert = null;
      this.generalCuttingForm.farm_id = null;
      this.generalCuttingForm.calendar_sel = null;
      this.hideView();
      this.cleanAll();
    },

    showCalendar() {
      this.messageAlert = null;
      this.generalCuttingForm.calendar_sel = null;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.generalCuttingForm.farm_id
      );

      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.generalCuttingForm.calendar_sel =
          element.calendars.length === 1 ? element.calendars[0].id : null;
      } else {
        this.isShowCalendar = false;
      }

      this.hideView();
    },

    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    cleanAll() {
      this.general_cutting_header_id = null;
      this.has_details = false;
      this.showTable = false;
      this.isFromReport = false;

      this.generalCuttingForm.nGeneralClusters = 1;
      this.generalCuttingForm.nRejectedClusters = 1;
      this.generalCuttingForm.nGeneralBoxes = 1;

      this.generalCuttingForm.general_clusters = [this.newGeneralClusterRow()];
      this.generalCuttingForm.general_rejected_clusters = [
        this.newRejectedClusterRow(),
      ];
      this.generalCuttingForm.general_boxes = [this.newGeneralBoxRow()];
    },

    newGeneralClusterRow() {
      return {
        ribbon_id: null,
        ribbon_name: null,
        ribbon_color: null,
        ribbon_text_color: null,
        age: null,
        quantity: null,
        calibration_average: null,
        latitude: null,
        longitude: null,
        altitude: null,
        full_date: null,
      };
    },

    newRejectedClusterRow() {
      return {
        cause_rejected_cluster_id: null,
        quantity: null,
        latitude: null,
        longitude: null,
        altitude: null,
        full_date: null,
      };
    },

    newGeneralBoxRow() {
      return {
        box_id: null,
        quantity: null,
        rejected: null,
        latitude: null,
        longitude: null,
        altitude: null,
        full_date: null,
      };
    },

    validate() {
      if (this.generalCuttingForm.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.generalCuttingForm.date_sel == null) {
        return this.validationInputsRequired('date');
      } else if (this.generalCuttingForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
        return false;
      } else {
        this.messageAlert = null;
        this.loadGeneralCutting();
        return true;
      }
    },

    initEmptyCapture() {
      this.general_cutting_header_id = null;
      this.has_details = false;

      this.generalCuttingForm.observation = '';
      this.generalCuttingForm.production_area = null;
      this.generalCuttingForm.traveled_area = null;
      this.generalCuttingForm.average_cluster_weight = null;
      this.generalCuttingForm.average_stem_weight = null;
      this.generalCuttingForm.average_number_hands = null;
      this.generalCuttingForm.average_length_second_hand = null;
      this.generalCuttingForm.average_length_last_hand = null;
      this.generalCuttingForm.average_number_fingers_box = null;
      this.generalCuttingForm.average_clusters_total_fingers = null;
      this.generalCuttingForm.quantity_people_packing = null;
      this.generalCuttingForm.quantity_people_harvest = null;
      this.generalCuttingForm.work_start_time = null;
      this.generalCuttingForm.work_end_time = null;

      this.generalCuttingForm.nGeneralClusters = 1;
      this.generalCuttingForm.nRejectedClusters = 1;
      this.generalCuttingForm.nGeneralBoxes = 1;

      this.generalCuttingForm.general_clusters = [this.newGeneralClusterRow()];
      this.generalCuttingForm.general_rejected_clusters = [
        this.newRejectedClusterRow(),
      ];
      this.generalCuttingForm.general_boxes = [this.newGeneralBoxRow()];

      this.showTable = true;
    },

    async getLocation() {
      const locationData = await this.getPosition();
      return {
        lat: locationData.lat,
        lng: locationData.lng,
        alt: locationData.alt,
      };
    },

    async setLocationAllRows() {
      try {
        this.location = await this.getLocation();
        const fullDate = moment().format('YYYY-MM-DD HH:mm:ss');

        for (let i = 0; i < this.generalCuttingForm.nGeneralClusters; i++) {
          this.$set(
            this.generalCuttingForm.general_clusters[i],
            'latitude',
            this.location.lat
          );
          this.$set(
            this.generalCuttingForm.general_clusters[i],
            'longitude',
            this.location.lng
          );
          this.$set(
            this.generalCuttingForm.general_clusters[i],
            'altitude',
            this.location.alt
          );
          this.$set(
            this.generalCuttingForm.general_clusters[i],
            'full_date',
            fullDate
          );
        }

        for (let i = 0; i < this.generalCuttingForm.nRejectedClusters; i++) {
          this.$set(
            this.generalCuttingForm.general_rejected_clusters[i],
            'latitude',
            this.location.lat
          );
          this.$set(
            this.generalCuttingForm.general_rejected_clusters[i],
            'longitude',
            this.location.lng
          );
          this.$set(
            this.generalCuttingForm.general_rejected_clusters[i],
            'altitude',
            this.location.alt
          );
          this.$set(
            this.generalCuttingForm.general_rejected_clusters[i],
            'full_date',
            fullDate
          );
        }

        for (let i = 0; i < this.generalCuttingForm.nGeneralBoxes; i++) {
          this.$set(
            this.generalCuttingForm.general_boxes[i],
            'latitude',
            this.location.lat
          );
          this.$set(
            this.generalCuttingForm.general_boxes[i],
            'longitude',
            this.location.lng
          );
          this.$set(
            this.generalCuttingForm.general_boxes[i],
            'altitude',
            this.location.alt
          );
          this.$set(
            this.generalCuttingForm.general_boxes[i],
            'full_date',
            fullDate
          );
        }
      } catch (error) {
        console.error('No se pudo obtener la ubicación:', error);
        SweetAlert.warning('common_words.geolocation_could_not_be_obtained');
      }
    },

    loadGeneralCutting() {
      this.showHideLoading(true);
      let date = moment(this.generalCuttingForm.date_sel).format('YYYY-MM-DD');

      Promise.all([
        Axios.getMasters(
          `cutting/generalcutting/catchs/${date}/${this.generalCuttingForm.farm_id}`
        ),
        Axios.getMasters(
          `generalcutting/ribbons/colors/${date}/${this.generalCuttingForm.farm_id}`
        ),
        Axios.getMasters('rejecteds/causes'),
        Axios.getMasters('boxes/boxes'),
      ])
        .then(
          async ([
            generalCuttingResponse,
            ribbonResponse,
            causesResponse,
            boxesResponse,
          ]) => {
            const res = generalCuttingResponse.data.data || {};

            this.ribbonsWeeks = ribbonResponse.data.colors_by_age || [];
            this.causes = causesResponse.data.data || [];
            this.boxesCatalog = boxesResponse.data.data.map((box) => ({
              ...box,
              name: `${box.code} - ${box.name}`,
            }));

            if (res.header_id) {
              this.has_details = true;
              this.general_cutting_header_id = res.header_id;

              const fields = [
                'observation',
                'production_area',
                'traveled_area',
                'average_cluster_weight',
                'average_stem_weight',
                'average_number_hands',
                'average_length_second_hand',
                'average_length_last_hand',
                'average_number_fingers_box',
                'average_clusters_total_fingers',
                'quantity_people_packing',
                'quantity_people_harvest',
                'work_start_time',
                'work_end_time',
                'unit_tara_weight',
                'length_unit',
              ];

              // Asignación dinámica iterando el arreglo
              fields.forEach((field) => {
                this.generalCuttingForm[field] = res[field] || null;
              });

              // Función para mapear arreglos o inicializarlos vacíos si no traen datos
              // aca se copia todo sin escribir propiedad por propiedad
              const mapOrInitArray = (arr, initFunc) => {
                return arr && arr.length > 0
                  ? arr.map((item) => ({ ...item }))
                  : [initFunc()];
              };

              // Nuevo mapeo de los arreglos optimizado
              this.generalCuttingForm.general_clusters = mapOrInitArray(
                res.general_clusters,
                this.newGeneralClusterRow
              );
              this.generalCuttingForm.general_rejected_clusters =
                mapOrInitArray(
                  res.general_rejected_clusters,
                  this.newRejectedClusterRow
                );
              this.generalCuttingForm.general_boxes = mapOrInitArray(
                res.general_boxes,
                this.newGeneralBoxRow
              );

              this.generalCuttingForm.nGeneralClusters =
                this.generalCuttingForm.general_clusters.length;
              this.generalCuttingForm.nRejectedClusters =
                this.generalCuttingForm.general_rejected_clusters.length;
              this.generalCuttingForm.nGeneralBoxes =
                this.generalCuttingForm.general_boxes.length;
            } else {
              this.initEmptyCapture();
              this.generalCuttingForm.unit_tara_weight =
                res.unit_tara_weight || null;
              this.generalCuttingForm.length_unit = res.length_unit || null;
              await this.setLocationAllRows();
            }

            this.showTable = true;
            this.showHideLoading();
          }
        )
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response.data.message || 'Error al cargar la captura'
          );
        });
    },

    addGeneralClusterRow() {
      this.generalCuttingForm.general_clusters.push(
        this.newGeneralClusterRow()
      );
      this.generalCuttingForm.nGeneralClusters++;
      this.setLocationAllRows();
    },

    removeGeneralClusterRow(index) {
      this.generalCuttingForm.general_clusters.splice(index, 1);
      this.generalCuttingForm.nGeneralClusters =
        this.generalCuttingForm.general_clusters.length;
    },

    addRejectedClusterRow() {
      this.generalCuttingForm.general_rejected_clusters.push(
        this.newRejectedClusterRow()
      );
      this.generalCuttingForm.nRejectedClusters++;
      this.setLocationAllRows();
    },

    removeRejectedClusterRow(index) {
      this.generalCuttingForm.general_rejected_clusters.splice(index, 1);
      this.generalCuttingForm.nRejectedClusters =
        this.generalCuttingForm.general_rejected_clusters.length;
    },

    addGeneralBoxRow() {
      this.generalCuttingForm.general_boxes.push(this.newGeneralBoxRow());
      this.generalCuttingForm.nGeneralBoxes++;
      this.setLocationAllRows();
    },

    removeGeneralBoxRow(index) {
      this.generalCuttingForm.general_boxes.splice(index, 1);
      this.generalCuttingForm.nGeneralBoxes =
        this.generalCuttingForm.general_boxes.length;
    },

    handleGeneralClusterChange(data) {
      this.$set(
        this.generalCuttingForm.general_clusters[data.index],
        data.name,
        data.selects
      );

      if (data.name === 'age') {
        const ribbon = this.ribbonsWeeks.find(
          (r) => Number(r.age || r.week) === Number(data.selects)
        );

        if (ribbon) {
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_id',
            ribbon.ribbon_id
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_name',
            ribbon.ribbon_name || ribbon.color_name
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_color',
            ribbon.ribbon_color || ribbon.color_code
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_text_color',
            ribbon.ribbon_text_color || ribbon.color_text
          );
        } else {
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_id',
            null
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_name',
            null
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_color',
            null
          );
          this.$set(
            this.generalCuttingForm.general_clusters[data.index],
            'ribbon_text_color',
            null
          );
        }
      }
    },

    handleRejectedClusterChange(data) {
      this.$set(
        this.generalCuttingForm.general_rejected_clusters[data.index],
        data.name,
        data.selects
      );
    },

    handleGeneralBoxChange(data) {
      this.$set(
        this.generalCuttingForm.general_boxes[data.index],
        data.name,
        data.selects
      );
    },

    getGeneralClusterRibbonName(index) {
      return this.generalCuttingForm.general_clusters[index].ribbon_name || '';
    },

    getGeneralClusterRibbonStyle(index) {
      const item = this.generalCuttingForm.general_clusters[index];
      return {
        backgroundColor: item.ribbon_color || '#ffffff',
        color: item.ribbon_text_color || '#000000',
        borderRadius: '5px',
        padding: '8px 12px',
        display: 'inline-block',
        minWidth: '90px',
      };
    },

    validateBeforeSave() {
      const form = this.generalCuttingForm;

      if (!form.farm_id) {
        this.validationInputsRequired('farm');
        return false;
      }

      if (!form.date_sel) {
        this.validationInputsRequired('date');
        return false;
      }

      if (!form.calendar_sel) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
        return false;
      }

      const requiredFields = [
        'production_area',
        'traveled_area',
        'average_cluster_weight',
        'average_stem_weight',
        'average_length_second_hand',
        'average_length_last_hand',
        'average_number_fingers_box',
        'average_clusters_total_fingers',
        'quantity_people_packing',
        'quantity_people_harvest',
        'work_start_time',
        'work_end_time',
      ];

      for (const field of requiredFields) {
        if (!form[field]) {
          this.validationInputsRequired(field);
          return false;
        }
      }

      return true;
    },

    async saveGeneralCutting() {
      if (!this.validateBeforeSave()) return;

      await this.setLocationAllRows();

      const form = this.generalCuttingForm;

      // Filtrar racimos rechazados
      const filteredRejectedClusters = (form.general_rejected_clusters || [])
        .filter(
          (item) => item.cause_rejected_cluster_id && Number(item.quantity) > 0
        )
        .map(
          ({
            cause_rejected_cluster_id,
            quantity,
            latitude,
            longitude,
            altitude,
            full_date,
          }) => ({
            cause_rejected_cluster_id,
            quantity,
            latitude,
            longitude,
            altitude: altitude || 0,
            full_date,
          })
        );

      //Campos necesarios para la cabecera
      const {
        farm_id,
        calendar_sel,
        observation,
        production_area,
        traveled_area,
        average_cluster_weight,
        average_stem_weight,
        average_number_hands,
        average_length_second_hand,
        average_length_last_hand,
        average_number_fingers_box,
        average_clusters_total_fingers,
        quantity_people_packing,
        quantity_people_harvest,
        work_start_time,
        work_end_time,
        user_id,
      } = form;

      const payload = {
        id: this.general_cutting_header_id,
        route: this.general_cutting_header_id
          ? 'cutting/generalcutting/update'
          : 'cutting/generalcutting/store',

        general_cutting: {
          farm_id,
          calendar_sel,
          observation,
          production_area,
          traveled_area,
          average_cluster_weight,
          average_stem_weight,
          average_number_hands,
          average_length_second_hand,
          average_length_last_hand,
          average_number_fingers_box,
          average_clusters_total_fingers,
          quantity_people_packing,
          quantity_people_harvest,
          work_start_time,
          work_end_time,
          user_id,
          save_date: moment(form.date_sel).format('YYYY-MM-DD'),
        },

        // Mapeo conciso de arreglos
        general_clusters: form.general_clusters.map(
          ({
            ribbon_id,
            age,
            quantity,
            calibration_average,
            latitude,
            longitude,
            altitude,
            full_date,
          }) => ({
            ribbon_id,
            age,
            quantity,
            calibration_average,
            latitude,
            longitude,
            altitude: altitude || 0,
            full_date,
          })
        ),

        general_rejected_clusters: filteredRejectedClusters,

        general_boxes: form.general_boxes.map(
          ({
            box_id,
            quantity,
            rejected,
            latitude,
            longitude,
            altitude,
            full_date,
          }) => ({
            box_id,
            quantity,
            rejected: rejected || 0,
            latitude,
            longitude,
            altitude: altitude || 0,
            full_date,
          })
        ),
      };

      this.showHideLoading(true);

      const request = this.general_cutting_header_id
        ? Axios.updateMaster(payload)
        : Axios.postMasters(payload);

      request
        .then((response) => {
          this.showHideLoading();
          this.cleanAll();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    deleteGeneralCutting() {
      if (this.has_details) {
        SweetAlert.delete(i18n.t('generalcutting.daily_general_report')).then(
          (result) => {
            if (result.value) {
              let data = {
                id: this.general_cutting_header_id,
                route: `cutting/generalcutting/delete`,
              };
              Axios.destroyMaster(data)
                .then((response) => {
                  this.showHideLoading();
                  this.cleanAll();
                  SweetAlert.success(response.data.message);
                })
                .catch((error) => SweetAlert.warning(error));
            }
          }
        );
      } else {
        SweetAlert.warning(i18n.t('production.no_record_to_delete'));
      }
    },
  },

  created() {
    this.showHideLoading(true);

    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('farms/farms/only')])
        .then(([farmsResponse]) => {
          this.farms = farmsResponse.data.data;
          this.loadFromRouteEdit();
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },

  beforeDestroy() {
    sessionStorage.removeItem('generalCuttingEdit');
  },
};
</script>
<style scoped>
::v-deep .card-title {
  font-weight: 400;
}

.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.custom-td-pd {
  padding: 0px !important;
}

.table-responsive {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
